import './EditorLabel.css';

interface EditorLabelProps {
  htmlFor?: string;
  label: string;
  flex?: boolean;
}

export default function EditorLabel({
  htmlFor,
  label,
  flex
}: EditorLabelProps) {
  return (
    <label className={`Label${flex ? ' is-flex' : ''}`} htmlFor={htmlFor}>
      {label}
    </label>
  );
}
